/**
 * キオスクモード
 * - /pages/kiosk 訪問でキオスクCookie有効化（24h）
 * - Cookie有効時: body.kiosk-mode クラス付与、トップバー表示、無操作タイマー起動
 * - 無操作10分 (warning 残り2分, critical 残り30秒) で自動リセット
 * - リセット: /account/logout → /cart/clear.js → Cookie/Storage 全消去 → /pages/kiosk へ
 * - 「次のお客様へ」ボタンで手動リセット（確認モーダル経由）
 * - 注文完了検出（referrer または kiosk_in_checkout フラグ + cart 空）で post-order モード
 *   - 全画面ロックダウンオーバーレイ表示、他の操作を遮断
 *   - 1分の短縮タイマーで自動リセット
 * - キオスク解除: /?kiosk=exit で Cookie 削除
 */

(function () {
  'use strict';

  const COOKIE_NAME = 'kiosk_mode';
  const COOKIE_MAX_AGE = 60 * 60 * 24; // 24h
  const IDLE_TIMEOUT_MS = 10 * 60 * 1000; // 通常: 10分
  const POST_ORDER_TIMEOUT_MS = 60 * 1000; // 注文後ロックダウン: 1分
  const WARNING_BEFORE_MS = 2 * 60 * 1000; // 残り2分で警告
  const CRITICAL_BEFORE_MS = 30 * 1000; // 残り30秒で重警告
  const POST_ORDER_COOKIE_MAX_AGE = 60 * 10; // post-order フラグ生存時間 10分

  // ---------- キオスク注文の連絡先 ----------
  // 受け取りは Shopify ネイティブの「ローカル受け取り (Local Pickup)」を使う想定 =
  // 配送先住所の入力が不要。よって店舗住所のクエリ注入は廃止。
  // メールはチェックアウト用のダミー (店が所有する catch-all アドレス。実在ドメインで
  // 検証を通し、確認メールがバウンスしないようにする)。
  const KIOSK_CHECKOUT_EMAIL = 'kiosk@michael-shop.com';

  function getCookie(name) {
    const match = document.cookie.match(new RegExp('(^|;\\s*)' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[2]) : null;
  }

  function setCookie(name, value, maxAge) {
    document.cookie =
      name + '=' + encodeURIComponent(value) + '; path=/; max-age=' + maxAge + '; SameSite=Lax';
  }

  function deleteCookie(name) {
    document.cookie = name + '=; path=/; max-age=0; SameSite=Lax';
  }

  // ---------- URL パラメータ処理 ----------
  const params = new URLSearchParams(window.location.search);

  // ?kiosk=exit で解除
  if (params.get('kiosk') === 'exit') {
    deleteCookie(COOKIE_NAME);
    try {
      localStorage.clear();
      sessionStorage.clear();
    } catch (_) {}
    // クエリ除去してリロード
    window.location.replace(window.location.pathname);
    return;
  }

  // /pages/kiosk または /{locale}/pages/kiosk を訪問したら Cookie 有効化
  function isKioskWelcomePath(path) {
    const cleanPath = (path || window.location.pathname).replace(/\/$/, '');
    return (
      cleanPath === '/pages/kiosk' ||
      /^\/[a-z]{2}(-[a-z]{2})?\/pages\/kiosk$/i.test(cleanPath)
    );
  }
  if (isKioskWelcomePath()) {
    // welcome 画面到着時は前の客の痕跡を必ず消す（リセット経由でない直接アクセスへの安全網）
    purgeCustomerSession({ keepKioskCookies: true });
    setCookie(COOKIE_NAME, '1', COOKIE_MAX_AGE);
  }

  // ---------- 顧客セッション完全破棄 ----------
  // チェックアウト時に入力された email/phone, Shopify顧客セッション, カート属性を全消去
  function clearCustomerCookies(keepKioskCookies) {
    // 顧客識別・チェックアウト状態・カート関連の Cookie を削除
    // HttpOnly Cookie（_secure_session_id 等）は /account/logout で破棄される
    const names = [
      'cart', 'cart_sig', 'cart_ver', 'cart_currency', 'cart_ts',
      'checkout', 'checkout_token', 'tracked_start_checkout',
      '_shopify_y', '_shopify_s', '_shopify_sa_p', '_shopify_sa_t',
      '_orig_referrer', '_landing_page', 'keep_alive',
      'secure_customer_sig', 'customer_locale',
      // キオスク内部状態フラグも一緒にクリア
      'kiosk_in_checkout', 'kiosk_post_order', 'kiosk_last_order',
    ];
    const hostname = window.location.hostname;
    const baseDomain = hostname.split('.').slice(-2).join('.');
    names.forEach((name) => {
      // パス・ドメインの組み合わせを総当たりで削除
      document.cookie = name + '=; path=/; max-age=0; SameSite=Lax';
      document.cookie = name + '=; path=/; max-age=0; SameSite=Lax; domain=' + hostname;
      if (baseDomain && baseDomain !== hostname) {
        document.cookie = name + '=; path=/; max-age=0; SameSite=Lax; domain=.' + baseDomain;
      }
    });
    if (!keepKioskCookies) {
      deleteCookie(COOKIE_NAME);
      deleteCookie('kiosk_locale');
    }
  }

  function purgeCustomerSession(opts) {
    const keepKioskCookies = opts && opts.keepKioskCookies;
    // 1. Shopify 顧客セッション破棄（HttpOnly Cookie もサーバ側で消える）
    try {
      fetch('/account/logout', { method: 'GET', credentials: 'same-origin' }).catch(() => {});
    } catch (_) {}
    // 2. カート空 + カート属性（kiosk_order, note 等）をリセット
    try {
      fetch('/cart/clear.js', { method: 'POST' }).catch(() => {});
    } catch (_) {}
    // 3. クライアント側ストレージ全消去
    try { sessionStorage.clear(); } catch (_) {}
    try { localStorage.clear(); } catch (_) {}
    // 4. JS から触れる Cookie を削除
    clearCustomerCookies(keepKioskCookies);
  }

  // Cookie チェック
  const isKiosk = getCookie(COOKIE_NAME) === '1';
  if (!isKiosk) return;

  // ---------- パス allowlist（許可リスト方式） ----------
  // キオスクで許可するパスを正規表現で定義。それ以外は /collections/all へ強制リダイレクト
  // ※ /admin, /blogs, /policies, /pages/about など全ての非許可パスを拒否
  const ALLOWED_PATH_PATTERNS = [
    /^\/?$/,                                  // ホーム
    /^\/collections(\/|$)/,                   // コレクション全般
    /^\/products(\/|$)/,                      // 商品ページ
    /^\/cart(\/|$|\.js)/,                     // カート
    /^\/checkout(\/|$|\?)/,                   // 旧チェックアウト
    /^\/checkouts(\/|$)/,                     // 新チェックアウト (Checkout Extensibility)
    /^\/pages\/kiosk\/?$/,                    // welcome ページのみ
    /^\/search(\/|$|\?)/,                     // 検索（必要なら C で別途制限）
    /^\/recommendations(\/|$)/,               // 関連商品 API
    /^\/apps(\/|$)/,                          // アプリプロキシ（必要に応じて）
  ];
  // ロケールプレフィックス対応 (/en/..., /zh-cn/...)
  const LOCALE_PREFIX_RE = /^\/[a-z]{2}(-[a-z]{2})?(\/|$)/i;

  function isAllowedPath(path) {
    let normalized = (path || '/').replace(/\/+$/, '') || '/';
    // ロケール接頭辞があれば剥がしてから判定
    const localeMatch = normalized.match(LOCALE_PREFIX_RE);
    if (localeMatch) {
      normalized = normalized.slice(localeMatch[0].length - 1) || '/';
    }
    return ALLOWED_PATH_PATTERNS.some((re) => re.test(normalized));
  }

  const currentPath = window.location.pathname;
  if (!isAllowedPath(currentPath)) {
    // 非許可パス → 商品一覧に強制リダイレクト
    window.location.replace('/collections/all');
    return;
  }

  // ---------- リンククリック時にも遷移先を検閲 ----------
  // 外部ドメイン or 非許可パスへのリンクは preventDefault でブロック
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[href]');
    if (!a) return;
    const href = a.getAttribute('href');
    if (!href) return;

    // javascript: スキーム・空 href・ハッシュリンクは通す or ブロック
    if (/^javascript:/i.test(href)) {
      e.preventDefault(); // XSS 風の URL を遮断
      return;
    }
    if (href.startsWith('#') || href === '') return;

    // mailto:, tel:, sms: 等は遮断
    if (/^(mailto|tel|sms|callto|skype):/i.test(href)) {
      e.preventDefault();
      return;
    }

    // 絶対URL の場合: 自ドメイン以外をブロック
    let url;
    try {
      url = new URL(href, window.location.origin);
    } catch (_) {
      e.preventDefault();
      return;
    }
    if (url.origin !== window.location.origin) {
      e.preventDefault();
      return;
    }

    // 自ドメインだが非許可パスならブロック
    if (!isAllowedPath(url.pathname)) {
      e.preventDefault();
      // チェックアウトボタン等は自前で処理されるためここで明示遷移不要
    }
  }, true); // capture フェーズで早めにフック

  // ---------- カートにキオスク属性を付与 ----------
  // 注文に "kiosk_order: yes" 属性を付けて管理画面で識別可能にする
  // ページ読み込み後に実行
  function tagCartAsKiosk() {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: { kiosk_order: 'yes' },
        note: '【キオスク注文】店頭受取・店頭支払いを選択してください',
      }),
    }).catch(() => {
      // 失敗しても運用に支障なし
    });
  }
  // カート操作があるページで実行（重複実行は問題なし）
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tagCartAsKiosk);
  } else {
    tagCartAsKiosk();
  }

  // ---------- チェックアウト URL ----------
  // Local Pickup 利用前提なので配送先住所は注入しない。
  // billing address は省略不可 (Shopify 仕様) なので店舗住所で prefill して
  // 客が触らず「次へ」だけで進めるようにする。Local Pickup + Manual Payment
  // (店頭でお支払い) を選んだ時はこの billing が請求書に乗るだけで実害なし。
  // メール / billing は best-effort prefill (Checkout Extensibility では query が
  // 無視される場合があるが、その時は単に空欄になるだけで無害)。
  function buildCheckoutUrl() {
    const params = new URLSearchParams();
    params.append('checkout[email]', KIOSK_CHECKOUT_EMAIL);
    params.append('checkout[billing_address][first_name]', '店頭');
    params.append('checkout[billing_address][last_name]', '受取');
    params.append('checkout[billing_address][address1]', '神田須田町1丁目7-1 ウィン神田高橋ビル5F');
    params.append('checkout[billing_address][city]', '千代田区');
    params.append('checkout[billing_address][province]', 'Tokyo');
    params.append('checkout[billing_address][country]', 'JP');
    params.append('checkout[billing_address][zip]', '101-0041');
    return '/checkout?' + params.toString();
  }

  function interceptCheckoutButtons() {
    // カートフォーム内のチェックアウトボタン
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('button[name="checkout"], a[href="/checkout"]');
      if (!btn) return;

      // カート属性を確実に付与してからチェックアウトへ
      e.preventDefault();

      // post-order 検出のため checkout 入場フラグをセット（戻ってきた時にカート空ならロックダウン発動）
      setCookie('kiosk_in_checkout', '1', 60 * 60); // 1h

      // 同期的に属性付与 → チェックアウト遷移
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: { kiosk_order: 'yes' },
          note: '【キオスク注文】店頭でお受け取り・お支払いください',
        }),
      })
        .then(() => {
          window.location.href = buildCheckoutUrl();
        })
        .catch(() => {
          // 失敗時はそのままチェックアウトへ
          window.location.href = '/checkout';
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', interceptCheckoutButtons);
  } else {
    interceptCheckoutButtons();
  }

  // ---------- body にクラス付与 ----------
  document.documentElement.classList.add('kiosk-mode');
  if (document.body) {
    document.body.classList.add('kiosk-mode');
  } else {
    document.addEventListener('DOMContentLoaded', () => {
      document.body.classList.add('kiosk-mode');
    });
  }

  // ---------- 動的チェックアウトボタンを監視して削除 ----------
  // Shopifyの Shop Pay / PayPal / GPay ボタンは JS で後から挿入されるため
  // MutationObserver で監視して削除する
  function hideDynamicCheckoutButtons() {
    const selectors = [
      '.cart__dynamic-checkout-buttons',
      '.additional-checkout-buttons',
      '.dynamic-checkout-buttons',
      '.dynamic-checkout__content',
      '#dynamic-checkout-cart',
      'shop-pay-wallet-button',
      'shopify-accelerated-checkout',
      'shopify-accelerated-checkout-cart',
      '.shopify-payment-button',
      '[data-shop-pay-button]',
      '#shopify-buyer-consent',
    ];
    selectors.forEach((sel) => {
      document.querySelectorAll(sel).forEach((el) => {
        el.style.display = 'none';
        // 完全に取り除く
        if (el.parentNode) {
          el.parentNode.removeChild(el);
        }
      });
    });
  }

  function setupDynamicButtonsObserver() {
    // 初回実行
    hideDynamicCheckoutButtons();

    // DOM変化を監視 (debounce: 大量の mutation で連続発火しないよう rAF でまとめる)
    let scheduled = false;
    const observer = new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        hideDynamicCheckoutButtons();
      });
    });
    observer.observe(document.body || document.documentElement, {
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupDynamicButtonsObserver);
  } else {
    setupDynamicButtonsObserver();
  }

  // ---------- Welcome画面 HTML 注入 ----------
  // /pages/kiosk アクセス時にテンプレートに関係なく welcome 画面を表示
  const LOCALE_PREFIXES = { ja: '', en: '/en', 'zh-cn': '/zh-CN' };

  const WELCOME_I18N = {
    ja: {
      title: 'いらっしゃいませ',
      subtitle: 'タブレットでカードを選んで<br>店頭でお受け取りください',
      cta: '🎴 注文を始める',
      step1: 'カードを選んでカートへ',
      step2: '店頭受取・店頭支払い',
      step3: 'レジでお会計',
      langLabel: '言語',
    },
    en: {
      title: 'Welcome',
      subtitle: 'Select cards on the tablet<br>and pick them up in store',
      cta: '🎴 Start Ordering',
      step1: 'Add cards to cart',
      step2: 'In-store pickup & payment',
      step3: 'Pay at the counter',
      langLabel: 'Language',
    },
    'zh-cn': {
      title: '欢迎光临',
      subtitle: '请在平板上选择卡牌<br>到店自取',
      cta: '🎴 开始订购',
      step1: '添加商品至购物车',
      step2: '到店自取·现场支付',
      step3: '在柜台结账',
      langLabel: '语言',
    },
  };

  function detectLocale() {
    const path = window.location.pathname;
    if (/^\/en(\/|$)/i.test(path)) return 'en';
    if (/^\/zh-cn(\/|$)/i.test(path)) return 'zh-cn';
    return getCookie('kiosk_locale') || 'ja';
  }

  function injectWelcomeScreen() {
    if (document.querySelector('.kiosk-welcome')) return; // 既に存在すればスキップ

    const locale = detectLocale();
    const t = WELCOME_I18N[locale] || WELCOME_I18N.ja;
    const prefix = LOCALE_PREFIXES[locale] || '';

    // 言語プルダウン用のインラインスタイル（CDNキャッシュ対策）
    if (!document.getElementById('kiosk-dropdown-inline-style')) {
      const style = document.createElement('style');
      style.id = 'kiosk-dropdown-inline-style';
      style.textContent = `
        .kiosk-lang-dropdown {
          position: absolute !important;
          top: 1.8rem !important;
          right: 2rem !important;
          z-index: 10 !important;
          display: flex !important;
          align-items: center !important;
          gap: 0.8rem !important;
          background: rgba(255, 255, 255, 0.15) !important;
          backdrop-filter: blur(8px) !important;
          border: 1px solid rgba(255, 255, 255, 0.25) !important;
          border-radius: 8px !important;
          padding: 0.6rem 1rem !important;
        }
        .kiosk-lang-dropdown__label {
          font-size: 1.3rem !important;
          color: rgba(255, 255, 255, 0.9) !important;
          font-weight: 500 !important;
          letter-spacing: 0.03em !important;
          white-space: nowrap !important;
          margin: 0 !important;
        }
        .kiosk-lang-dropdown__select {
          background: rgba(255, 255, 255, 0.95) !important;
          color: #1a1a2e !important;
          border: none !important;
          border-radius: 4px !important;
          padding: 0.6rem 2.4rem 0.6rem 0.9rem !important;
          font-size: 1.4rem !important;
          font-weight: 700 !important;
          font-family: inherit !important;
          cursor: pointer !important;
          appearance: none !important;
          -webkit-appearance: none !important;
        }
        .kiosk-lang-dropdown__select:hover,
        .kiosk-lang-dropdown__select:focus-visible {
          background-color: #fff !important;
          outline: none !important;
          box-shadow: 0 0 0 3px rgba(255, 209, 102, 0.6) !important;
        }
        @media screen and (max-width: 749px) {
          .kiosk-lang-dropdown {
            top: 1rem !important;
            right: 1rem !important;
            padding: 0.4rem 0.7rem !important;
            gap: 0.5rem !important;
          }
          .kiosk-lang-dropdown__label { display: none !important; }
          .kiosk-lang-dropdown__select {
            font-size: 1.2rem !important;
            padding: 0.5rem 2rem 0.5rem 0.7rem !important;
          }
        }
      `;
      document.head.appendChild(style);
    }

    const welcome = document.createElement('div');
    welcome.className = 'kiosk-welcome';
    welcome.setAttribute('data-kiosk-welcome-injected', '');
    welcome.innerHTML = `
      <div class="kiosk-lang-dropdown">
        <label class="kiosk-lang-dropdown__label" for="kiosk-lang-select">
          🌐 ${t.langLabel}
        </label>
        <select id="kiosk-lang-select" class="kiosk-lang-dropdown__select" data-kiosk-lang-select>
          <option value="ja" ${locale === 'ja' ? 'selected' : ''}>🇯🇵 日本語</option>
          <option value="en" ${locale === 'en' ? 'selected' : ''}>🇺🇸 English</option>
          <option value="zh-cn" ${locale === 'zh-cn' ? 'selected' : ''}>🇨🇳 简体中文</option>
        </select>
      </div>
      <div class="kiosk-welcome__inner">
        <div class="kiosk-welcome__logo">🎴</div>
        <h1 class="kiosk-welcome__title">${t.title}</h1>
        <p class="kiosk-welcome__subtitle">${t.subtitle}</p>
        <a href="${prefix}/collections/all" class="kiosk-welcome__cta" data-kiosk-start>
          ${t.cta}
        </a>
        <div class="kiosk-welcome__steps">
          <div class="kiosk-welcome__step">
            <div class="kiosk-welcome__step-num">1</div>
            <div class="kiosk-welcome__step-text">${t.step1}</div>
          </div>
          <div class="kiosk-welcome__step">
            <div class="kiosk-welcome__step-num">2</div>
            <div class="kiosk-welcome__step-text">${t.step2}</div>
          </div>
          <div class="kiosk-welcome__step">
            <div class="kiosk-welcome__step-num">3</div>
            <div class="kiosk-welcome__step-text">${t.step3}</div>
          </div>
        </div>
      </div>
    `;

    // プルダウン変更で言語切替
    const select = welcome.querySelector('[data-kiosk-lang-select]');
    select?.addEventListener('change', (e) => {
      const lang = e.target.value;
      setCookie('kiosk_locale', lang, COOKIE_MAX_AGE);
      const newPrefix = LOCALE_PREFIXES[lang] || '';
      window.location.href = newPrefix + '/pages/kiosk';
    });
    document.body.appendChild(welcome);
  }

  // ---------- UI 生成 ----------
  function buildUI() {
    // welcome ページ上では一部 UI を省略（そのページ自体が待機画面）
    const isWelcomePage = isKioskWelcomePath();

    // Welcome 画面を強制注入（テンプレート未設定でも動くように）
    if (isWelcomePage) {
      injectWelcomeScreen();
      // welcome 画面自体が待機表示のため、上部バーは出さない
    } else {
      // トップバー（通常ページのみ表示）
      const bar = document.createElement('div');
      bar.className = 'kiosk-bar';
      bar.innerHTML = `
        <span class="kiosk-bar__label">
          <span class="kiosk-bar__label-jp">キオスクモード</span>
          <span class="kiosk-bar__label-en">KIOSK MODE</span>
        </span>
        <span class="kiosk-bar__timer-wrap">
          <span class="kiosk-bar__timer-note">
            <span>無操作で自動リセット</span>
            <span class="kiosk-bar__timer-note-en">Auto-reset when idle</span>
          </span>
          <span class="kiosk-bar__timer" data-kiosk-timer>10:00</span>
        </span>
        <button type="button" class="kiosk-bar__reset" data-kiosk-reset>
          <span>次のお客様へ</span>
          <span class="kiosk-bar__reset-en">Next Customer</span>
        </button>
      `;
      document.body.prepend(bar);
    }

    // 確認モーダル
    const confirm = document.createElement('div');
    confirm.className = 'kiosk-confirm';
    confirm.setAttribute('data-kiosk-confirm', '');
    confirm.innerHTML = `
      <div class="kiosk-confirm__box">
        <h2 class="kiosk-confirm__title">
          リセットしますか？
          <span class="kiosk-confirm__title-en">Reset session?</span>
        </h2>
        <p class="kiosk-confirm__text">
          カートの中身を全てクリアして、<br>ウェルカム画面に戻ります。
          <span class="kiosk-confirm__text-en">Cart will be cleared and you'll return to the welcome screen.</span>
        </p>
        <div class="kiosk-confirm__actions">
          <button type="button" class="kiosk-confirm__btn kiosk-confirm__btn--secondary" data-kiosk-cancel>
            <span>キャンセル</span>
            <span class="kiosk-confirm__btn-en">Cancel</span>
          </button>
          <button type="button" class="kiosk-confirm__btn kiosk-confirm__btn--primary" data-kiosk-confirm-reset>
            <span>リセットする</span>
            <span class="kiosk-confirm__btn-en">Reset</span>
          </button>
        </div>
      </div>
    `;
    document.body.appendChild(confirm);

    // トースト
    const toast = document.createElement('div');
    toast.className = 'kiosk-toast';
    toast.setAttribute('data-kiosk-toast', '');
    toast.textContent = '無操作のため間もなくリセットします...';
    document.body.appendChild(toast);
  }

  // ---------- リセット処理 ----------
  // 顧客セッションを完全破棄 (ログアウト + カートクリア + Cookie/Storage 削除) して
  // welcome 画面へ戻す。fetch がハングしてもキオスクが固まらないよう、
  // フェイルセーフタイマーで「何があっても 2 秒以内に welcome へ戻る」ことを保証する。
  async function performReset() {
    const locale = getCookie('kiosk_locale') || 'ja';
    const prefixes = { ja: '', en: '/en', 'zh-cn': '/zh-CN' };
    const prefix = prefixes[locale] || '';
    const welcomeUrl = prefix + '/pages/kiosk';

    let navigated = false;
    const go = () => {
      if (navigated) return;
      navigated = true;
      window.location.replace(welcomeUrl);
    };
    // フェイルセーフ: fetch が詰まっても 2 秒後に必ず welcome へ
    const failsafe = setTimeout(go, 2000);

    // logout + cart clear を最大 1.5 秒だけ待つ (ハングしても先へ進む)
    const withTimeout = (p, ms) =>
      Promise.race([p, new Promise((resolve) => setTimeout(resolve, ms))]);
    try {
      await withTimeout(
        Promise.all([
          fetch('/account/logout', { method: 'GET', credentials: 'same-origin' }).catch(() => {}),
          fetch('/cart/clear.js', { method: 'POST' }).catch(() => {}),
        ]),
        1500
      );
    } catch (_) {}
    try { sessionStorage.clear(); } catch (_) {}
    try { localStorage.clear(); } catch (_) {}
    clearCustomerCookies(true); // kiosk_mode と kiosk_locale は維持

    clearTimeout(failsafe);
    go();
  }

  // ---------- 無操作タイマー ----------
  let idleStart = Date.now();
  let tickInterval = null;
  let confirmModalOpen = false;
  let postOrderMode = false;

  function resetIdleTimer() {
    idleStart = Date.now();
  }

  function formatMs(ms) {
    const s = Math.max(0, Math.ceil(ms / 1000));
    const m = Math.floor(s / 60);
    const sec = s % 60;
    return m + ':' + (sec < 10 ? '0' : '') + sec;
  }

  function tick() {
    // ウェルカム画面ではタイマー動作なし
    if (isKioskWelcomePath()) {
      return;
    }

    if (confirmModalOpen) return; // 確認中はタイマー停止

    const elapsed = Date.now() - idleStart;
    const timeoutMs = postOrderMode ? POST_ORDER_TIMEOUT_MS : IDLE_TIMEOUT_MS;
    const remaining = timeoutMs - elapsed;

    if (remaining <= 0) {
      performReset();
      return;
    }

    // post-order ロックダウン中は独自のカウントダウン表示のみ更新
    if (postOrderMode) {
      const poTimerEls = document.querySelectorAll('[data-kiosk-post-order-timer]');
      poTimerEls.forEach((el) => { el.textContent = formatMs(remaining); });
      return;
    }

    // 通常モードのトップバー更新
    const timerEl = document.querySelector('[data-kiosk-timer]');
    const toastEl = document.querySelector('[data-kiosk-toast]');
    if (!timerEl) return;

    timerEl.textContent = formatMs(remaining);
    timerEl.classList.toggle('is-warning', remaining < WARNING_BEFORE_MS && remaining >= CRITICAL_BEFORE_MS);
    timerEl.classList.toggle('is-critical', remaining < CRITICAL_BEFORE_MS);

    if (toastEl) {
      if (remaining < WARNING_BEFORE_MS) {
        toastEl.innerHTML =
          '⚠ 何も操作されていないため、あと <strong>' +
          formatMs(remaining) +
          '</strong> でリセットされます（画面をタップすると延長）' +
          '<span class="kiosk-toast__en">No activity detected — resetting in ' +
          formatMs(remaining) +
          '. Tap to stay.</span>';
        toastEl.classList.add('is-visible');
      } else {
        toastEl.classList.remove('is-visible');
      }
    }
  }

  // ---------- 注文後ロックダウン（post-order mode） ----------
  // 注文完了 → 戻ってきたお客さんが「次のお客様へ」を押さずに離席するのを防ぐため
  // 全画面オーバーレイで他の操作を遮断し、1分でリセット
  async function checkPostOrderState() {
    // welcome 画面は常にフレッシュ状態なのでスキップ
    if (isKioskWelcomePath()) return;

    // 既に post-order 状態として記録済み → 即オーバーレイ表示
    if (getCookie('kiosk_post_order') === '1') {
      enterPostOrderMode();
      return;
    }

    // 初回検出: checkout に入ったフラグ または referrer が checkout/orders & cart 空
    const inCheckoutFlag = getCookie('kiosk_in_checkout') === '1';
    const cameFromCheckout =
      document.referrer && /\/(checkouts|orders|thank_you)\//i.test(document.referrer);

    if (!inCheckoutFlag && !cameFromCheckout) return;

    try {
      const res = await fetch('/cart.js', { credentials: 'same-origin' });
      const cart = await res.json();
      if (cart && cart.item_count === 0) {
        // 注文完了とみなす → post-order 状態を Cookie に永続化
        setCookie('kiosk_post_order', '1', POST_ORDER_COOKIE_MAX_AGE);
        deleteCookie('kiosk_in_checkout');
        enterPostOrderMode();
      }
    } catch (_) {}
  }

  function enterPostOrderMode() {
    if (postOrderMode) return;
    postOrderMode = true;
    buildPostOrderOverlay();
    resetIdleTimer(); // 1分カウントダウンを今から開始
    // 即座に1回 tick して表示を初期化
    tick();
  }

  function buildPostOrderOverlay() {
    if (document.querySelector('.kiosk-post-order')) return;

    // 注文番号 Cookie（Order Status Page の追加スクリプトで書き込み）
    const orderName = getCookie('kiosk_last_order');

    const overlay = document.createElement('div');
    overlay.className = 'kiosk-post-order';
    overlay.setAttribute('data-kiosk-post-order', '');
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'ご注文完了');
    overlay.innerHTML =
      '<div class="kiosk-post-order__inner">' +
        '<div class="kiosk-post-order__icon">✅</div>' +
        '<h1 class="kiosk-post-order__title">' +
          'ご注文ありがとうございました' +
          '<span class="kiosk-post-order__title-en">Thank you for your order</span>' +
        '</h1>' +
        (orderName
          ? '<div class="kiosk-post-order__order-block">' +
              '<div class="kiosk-post-order__order-label">' +
                'ご注文番号' +
                '<span class="kiosk-post-order__order-label-en">Order Number</span>' +
              '</div>' +
              '<div class="kiosk-post-order__order-number">' +
                escapeHtml(orderName) +
              '</div>' +
              '<div class="kiosk-post-order__order-hint">' +
                'レジでこの番号をお伝えください' +
                '<span class="kiosk-post-order__order-hint-en">Show this number at the counter</span>' +
              '</div>' +
            '</div>'
          : '') +
        '<p class="kiosk-post-order__lead">' +
          'レジでお支払い・商品をお受け取りください<br>' +
          '<span class="kiosk-post-order__lead-en">Please pay and pick up at the counter</span>' +
        '</p>' +
        '<button type="button" class="kiosk-post-order__btn" data-kiosk-post-order-reset>' +
          '次のお客様へ' +
          '<span class="kiosk-post-order__btn-en">Next Customer</span>' +
        '</button>' +
        '<p class="kiosk-post-order__timer-note">' +
          'あと <strong data-kiosk-post-order-timer>1:00</strong> で自動リセット' +
          '<span class="kiosk-post-order__timer-note-en">Auto-reset in <strong data-kiosk-post-order-timer>1:00</strong></span>' +
        '</p>' +
      '</div>';
    document.body.appendChild(overlay);
  }

  // Cookie 値を innerHTML に流すため最低限のエスケープ
  function escapeHtml(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function startTimer() {
    if (tickInterval) clearInterval(tickInterval);
    tickInterval = setInterval(tick, 500);
    tick();
  }

  // ---------- イベント登録 ----------
  function bindEvents() {
    // アクティビティ検知
    // post-order モード中は意図的に延長させない（1分で必ずリセットされるよう）
    ['click', 'touchstart', 'keydown', 'scroll', 'pointermove'].forEach((type) => {
      document.addEventListener(
        type,
        () => {
          if (!confirmModalOpen && !postOrderMode) resetIdleTimer();
        },
        { passive: true }
      );
    });

    // ---------- 右クリック・コンテキストメニュー無効化（D） ----------
    document.addEventListener('contextmenu', (e) => {
      e.preventDefault();
    });

    // ---------- キーボードショートカットブロック（E） ----------
    // ※ Ctrl+T/W/L 等のブラウザ予約ショートカットは JS では止められない（OS Kiosk 設定が必要）
    document.addEventListener('keydown', (e) => {
      const key = (e.key || '').toUpperCase();
      const ctrl = e.ctrlKey || e.metaKey;

      // F12 - 開発者ツール
      if (e.key === 'F12') { e.preventDefault(); e.stopPropagation(); return; }
      // F5 / Ctrl+R - リロードはあえて許可（運用上必要なため）
      // F11 - フルスクリーン切替（タブレットでは無害）
      // Ctrl+Shift+I/J/C - 開発者ツール
      if (ctrl && e.shiftKey && (key === 'I' || key === 'J' || key === 'C')) {
        e.preventDefault(); e.stopPropagation(); return;
      }
      // Ctrl+U - ソース表示
      if (ctrl && key === 'U') { e.preventDefault(); e.stopPropagation(); return; }
      // Ctrl+P - 印刷
      if (ctrl && key === 'P') { e.preventDefault(); e.stopPropagation(); return; }
      // Ctrl+S - ページ保存
      if (ctrl && key === 'S') { e.preventDefault(); e.stopPropagation(); return; }
      // Ctrl+H - 履歴
      if (ctrl && key === 'H') { e.preventDefault(); e.stopPropagation(); return; }
      // Ctrl+J - ダウンロード
      if (ctrl && key === 'J' && !e.shiftKey) { e.preventDefault(); e.stopPropagation(); return; }
      // Alt+← / Alt+→ - 戻る/進む
      if (e.altKey && (e.key === 'ArrowLeft' || e.key === 'ArrowRight')) {
        e.preventDefault(); e.stopPropagation(); return;
      }
      // Backspace で戻る（フォーカスが input/textarea でない場合のみ）
      if (e.key === 'Backspace') {
        const tag = (e.target.tagName || '').toLowerCase();
        const editable = tag === 'input' || tag === 'textarea' || e.target.isContentEditable;
        if (!editable) { e.preventDefault(); e.stopPropagation(); return; }
      }
    }, true);

    // 「次のお客様」ボタン
    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-kiosk-reset]')) {
        confirmModalOpen = true;
        document.querySelector('[data-kiosk-confirm]')?.classList.add('is-open');
      }
      if (e.target.closest('[data-kiosk-cancel]')) {
        confirmModalOpen = false;
        document.querySelector('[data-kiosk-confirm]')?.classList.remove('is-open');
        resetIdleTimer();
      }
      if (e.target.closest('[data-kiosk-confirm-reset]')) {
        performReset();
      }
      // post-order ロックダウン中の「次のお客様へ」（確認なしで即リセット）
      if (e.target.closest('[data-kiosk-post-order-reset]')) {
        performReset();
      }
    });
  }

  // ---------- 起動 ----------
  function init() {
    buildUI();
    bindEvents();
    startTimer();
    checkPostOrderState(); // 注文後ロックダウン判定（非同期、welcome 以外で動く）
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
